import React from 'react';
import { IoVolumeMediumSharp, IoVolumeMute } from 'react-icons/io5';
import { FaPause, FaCommentDots } from 'react-icons/fa6';
import './PlayerControls.scss';

// 画面右上の操作ボタン。
//
// 一時停止はトグルにしない（押したら止まるだけ）。
// 止めている間はこのボタン群ごと隠し、再開は画面中央の再生ボタンで行う。
// 「止める手段」と「戻す手段」を1箇所ずつに絞ったほうが迷わないため。
//
// ミュートだけは状態の切り替え。アイコンとラベルは「押すとどうなるか」で揃えている
// （ミュート中は音が戻るアイコン＋「ミュート解除」）。
//
// 話題を変えるは1段下に置く。上段が「いま流れているものの操作」なのに対し、
// こちらは会話そのものを作り直す操作で、性質が違うため段を分けている。
const PlayerControls = ({ muted, onToggleMute, onPause, onChangeTopic }) => (
  <div className="player-controls">
    <div className="player-row">
      <button
        type="button"
        className="player-btn"
        onClick={onToggleMute}
        aria-pressed={muted}
        title={muted ? 'ミュート解除' : 'ミュート'}
      >
        <span className="icon" aria-hidden="true">
          {muted ? <IoVolumeMediumSharp /> : <IoVolumeMute />}
        </span>
        <span className="label">{muted ? 'ミュート解除' : 'ミュート'}</span>
      </button>

      <button type="button" className="player-btn" onClick={onPause} title="一時停止">
        <span className="icon" aria-hidden="true">
          <FaPause />
        </span>
        <span className="label">一時停止</span>
      </button>
    </div>

    <button
      type="button"
      className="player-btn player-btn--topic"
      onClick={onChangeTopic}
      title="話題を変える"
    >
      <span className="icon" aria-hidden="true">
        <FaCommentDots />
      </span>
      <span className="label">話題を変える</span>
    </button>
  </div>
);

export default PlayerControls;
